var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cobros'),_c('pedidos-proveedor'),_c('pedidos-online'),_c('mensajes'),_c('deposit-movements'),_c('problemas-al-facturar'),_c('stock-minimo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }